import { ToggleGroup, ToggleGroupItem } from 'src/components/ui/toggle-group';
import { Control, Controller } from 'react-hook-form';
import { clsx } from 'clsx';
import type { FreshdeskHelpCenterFormValues } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateFreshdeskIntegrationPopup/FreshdeskIntegrationForm2/freshdeskHelpCenterFormValues';

export const FreshdeskHelpCenterIsPrivate = ({
  control,
}: {
  control: Control<FreshdeskHelpCenterFormValues>;
}) => {
  return (
    <div className={'flex flex-col gap-2.5'}>
      <div>
        <Controller
          control={control}
          name="is_private"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <ToggleGroup
              type="single"
              className={clsx('flex gap-1.5 justify-items-stretch items-stretch w-full')}
              onValueChange={onChange}
              defaultValue={value}
              value={value}
            >
              <ToggleGroupItem
                className={'flex flex-1 items-center justify-center'}
                value={'public'}
              >
                Public Articles Only
              </ToggleGroupItem>
              <ToggleGroupItem
                className={'flex flex-1 items-center justify-center'}
                value={'private'}
              >
                Public & Private Articles
              </ToggleGroupItem>
            </ToggleGroup>
          )}
        />
      </div>
    </div>
  );
};
